import { Modal, TextInput } from 'is24-corecss';
import React, { useState } from 'react';
import { css } from '@emotion/css';

import PeopleSVG from './PeopleSVG';
import { VALENTINES_UPSELL_PARAM } from './constants';
import { PlusBadge } from '../display/plusBadge/PlusBadge';
import UnitedSVG from './UnitedSVG';
import { useIntl } from '@/i18n/hooks/useIntl';
import { useQueryParam } from '@/customHooks/useQueryParam.hook';
import { Msg } from '@/i18n';

interface ValentinesUpsellModalProps {
  onClose: () => void;
}

const styles = {
  iconWrapper: css`
    flex-shrink: 0;
  `,
  textWeak: css`
    color: var(--color-text-weak);
  `,
};

export const ValentinesUpsellModal = ({ onClose }: ValentinesUpsellModalProps) => {
  const { t } = useIntl();
  const isModalOpen = !!useQueryParam(VALENTINES_UPSELL_PARAM);
  const [formData, setFormData] = useState({ name: '', email: '' });

  const handleInputChange = (field: keyof typeof formData) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = () => {
    // TODO: Implement submit logic
    onClose();
  };

  if (!isModalOpen) {
    return null;
  }

  return (
    <Modal
      visible={true}
      title={t({ id: 'valentinesUpsellBanner.modal.title' })}
      onClose={onClose}
      primaryFooterBtn={
        <Modal.FooterPrimaryBtn label={t({ id: 'valentinesUpsellBanner.modal.confirmBtn' })} onClick={handleSubmit} />
      }
    >
      <div className='display-flex grid-align-start gap-s margin-bottom-l'>
        <div className={styles.iconWrapper}>
          <PeopleSVG />
        </div>
        <div className='display-flex grid-justify-space-between grid-align-start one-whole'>
          <div>
            <Msg
              id='valentinesUpsellBanner.modal.description'
              defaultMessage=''
              values={{
                suchen: <PlusBadge variant='rent' />,
              }}
            />
          </div>
          <div>
            <UnitedSVG />
          </div>
        </div>
      </div>
      <div className={`font-body-medium-regular ${styles.textWeak} margin-bottom-s`}>
        {t({ id: 'valentinesUpsellBanner.modal.requiredField' })}
      </div>
      <div className='margin-bottom-m'>
        <TextInput
          id='valentines-name'
          label={t({ id: 'valentinesUpsellBanner.modal.nameLabel' })}
          placeholder=''
          value={formData.name}
          onChange={handleInputChange('name')}
        />
      </div>
      <div className='margin-bottom-m'>
        <TextInput
          id='valentines-email'
          label={t({ id: 'valentinesUpsellBanner.modal.emailLabel' })}
          placeholder=''
          type='email'
          value={formData.email}
          onChange={handleInputChange('email')}
        />
      </div>
      <div className='notification notification--neutral notification--flat margin-top-l'>
        <div className='notification__icon'>
          <span className='s24-icons-s24_info_circle_24' />
        </div>
        <div className='notification__content'>
          <div className='notification__message'>{t({ id: 'valentinesUpsellBanner.modal.validityInfo' })}</div>
        </div>
      </div>
    </Modal>
  );
};
